var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("j-employee-form-update", {
            ref: "employeeForm",
            attrs: { mode: "update" },
            on: { data: _vm.getData }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "12", md: "9" } }, [
            _c(
              "div",
              { staticClass: "m__t--20" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn blue",
                    on: { click: _vm.saveUpdateEmployee }
                  },
                  [_vm._v("Update")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12", md: "3" } })
        ],
        1
      ),
      _vm._v(" "),
      _c("br")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70ef8394", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ef8394","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/detail/jDetail.vue
// module id = null
// module chunks = 